import React, { memo } from 'react'
import { Sheet as TamaguiSheet, View, YStack } from 'tamagui'

export const SheetScrollView = React.forwardRef<any, any>((props, ref) => (
  <TamaguiSheet.ScrollView
    ref={ref}
    disableScrollViewPanResponder={true}
    bounces={false}
    {...props}
  />
))

export const SheetDragHandle = memo(function SheetDragHandle({
  onDarkBackground = false,
}: {
  onDarkBackground?: boolean
}) {
  return (
    <YStack h={22} minHeight={22} w="100%" ai="center" jc="center" flexShrink={0}>
      <View
        width={40}
        height={5}
        borderRadius={9999}
        backgroundColor={onDarkBackground ? 'rgba(255,255,255,0.38)' : 'rgba(0,0,0,0.22)'}
      />
    </YStack>
  )
})

type SheetProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  children?: React.ReactNode
  snapPoints?: number[]
  backgroundColor?: string
}

export function Sheet({
  open,
  onOpenChange,
  children,
  snapPoints = [85],
  backgroundColor = 'white',
}: SheetProps) {
  return (
    <TamaguiSheet
      modal
      open={open}
      onOpenChange={onOpenChange}
      animation="medium"
      snapPointsMode="percent"
      snapPoints={snapPoints}
      defaultPosition={1}
      dismissOnSnapToBottom
      dismissOnOverlayPress
    >
      <TamaguiSheet.Overlay
        animation="lazy"
        enterStyle={{ opacity: 0 }}
        exitStyle={{ opacity: 0 }}
        backgroundColor="rgba(0,0,0,0.25)"
      />

      <TamaguiSheet.Frame
        backgroundColor={backgroundColor}
        borderTopLeftRadius="$6"
        borderTopRightRadius="$6"
        flex={1}
        overflow="hidden"
      >
        <YStack flex={1} width="100%" backgroundColor={backgroundColor}>
          {children}
        </YStack>
      </TamaguiSheet.Frame>
    </TamaguiSheet>
  )
}
